import React from 'react'

interface Steps {
    currentStep: string;
    setCurrentStep: any;
  }
    
    const StepIndicator: React.FC<Steps> = ({
        currentStep,
      setCurrentStep,
    }) => {
    return (
      <div className="mb-8">
        <div className="flex items-center justify-between">
          <div className="flex-1 flex items-center">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center ${
                currentStep === "discountInfo" ||
                currentStep === "eligibility" 
                  ? "bg-green-600 text-white"
                  : "bg-gray-200"
              }`}
            >
              1
            </div>
            <div className="flex-1 h-1 mx-2 bg-gray-200">
              <div
                className={`h-full ${
                  currentStep === "discountInfo" || currentStep === "eligibility"
                    ? "bg-green-600"
                    : "bg-gray-200"
                }`}
              />
            </div>
          </div>

         

          <div className="flex items-center">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center ${
                currentStep === "eligibility"
                  ? "bg-green-600 text-white"
                  : "bg-gray-200"
              }`}
            >
              2
            </div>
          </div>
        </div>

        <div className="flex justify-between mt-2 text-sm">
          <div className="text-center flex-1">Discount Information</div>
          <div className="text-center flex-1">Eligibility & Conditions</div>
        </div>
      </div>
    );
  };

export default StepIndicator